import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  heading: {
    fontSize: '2rem',
  },
  bold: {
    fontWeight: 400,
  },
  container: {
    width: '350px',
  },
  botContainer: {
    minWidth: '30vw',
  },
}));
